import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export default function CtaSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          className={`bg-background-50 border border-background-200/70 rounded-xl md:rounded-2xl p-6 md:p-10 lg:p-14 text-center transition-all duration-700 ${
            visible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-8"
          }`}
        >
          <div className="max-w-3xl mx-auto">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-5">
              <i className="ri-calendar-check-line text-2xl md:text-3xl" />
            </div>
            <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Sẵn sàng nâng tầm sức khỏe?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8 font-body leading-relaxed">
              Đặt lịch trải nghiệm ngay hôm nay và nhận ưu đãi đặc biệt chỉ 139K cho lần đầu tiên. Đội ngũ chuyên viên của Xanh Wellness luôn sẵn sàng đồng hành cùng bạn trên hành trình chăm sóc sức khỏe.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <Link
                to="/booking"
                className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-sm md:text-base font-semibold whitespace-nowrap rounded-md transition-colors"
              >
                Đặt lịch ngay
              </Link>
              <a
                href="tel:0909123456"
                className="px-8 py-3.5 bg-background-100 hover:bg-background-200 text-foreground-800 border border-background-300/60 font-label text-sm md:text-base font-medium whitespace-nowrap rounded-md transition-colors"
              >
                <i className="ri-phone-line mr-2" />
                Gọi tư vấn
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}